import * as React from "react";
import { FC, useState, useEffect } from "react";
import axios from "axios";
import { ModalVerify } from "./VerifyComponents/ModalVerify";
import { ConfirmCode } from "./VerifyComponents/ConfirmCode";
import { Cel } from "./VerifyComponents/Cel";



export const NewVerifyCel = ({
  ap,
  passPortal,
  deviceId,
}) => {

  const [loading, setLoading] = useState(false);
  const [loadingAskCode, setLoadingAskCode] = useState<boolean>(false);
  const [erroAskCode, setErroAskCode] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [valid, setValid] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [body, setBody] = useState<{ap_mac: string, device_id: string, verify: any, code?: string, phoneNumber?: any}>({
    ap_mac: ap ? ap.ap_mac : "",
    device_id: deviceId ? deviceId.replace(/:/g, "") : "",
    verify: "sms",
  });
  let body_reset = {
    ap_mac: ap ? ap.ap_mac : "",
    device_id: deviceId ? deviceId.replace(/:/g, "") : "",
    verify: "sms",
  };

  useEffect(() => {
    //getMessageWelcome();
  }, []);


  const sentSMS = async (value) => {
    try {
      setLoadingAskCode(true);
      let b: any = await setFields(value);
      let res = await axios.get("/sms", {
        params: {
          phoneNumber: b.phoneNumber,
        },
      });
      console.log(res.data);
      setLoadingAskCode(false);
      setCodeSent(true);
      setErroAskCode("");
    } catch (err) {
      setCodeSent(false);
      setErroAskCode("Hubo un error, intentelo de nuevo");
      setLoadingAskCode(false);

    }
  };

  const confirm = async (value, code) => {
    setLoading(true);
    setShowModal(true);
    let b = await setFields(value, code);
    try {
      let resp = await axios.post("/sharedfi/code", {
        fields: b,
      });
      if (resp.data.error) {
        setValid(false);
      } else {
        setValid(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setValid(false);
      setShowModal(false);
    }
  };

  const setFields = (value, code?) => {
    return new Promise((resolve, reject) => {
      let key = "";
      setBody({
        ...body_reset,
        phoneNumber: value,
        code,
      });
      key = "phoneNumber";
     
      resolve({
        ...body_reset,
        verify:"sms",
        [key]: value,
        code: code ? code : "",
      });        
    });
  };

  const getMessageWelcome = async () => {
    try {
      let res = await axios.get("/message");
     // setMessage(res.data.message);
    } catch (error) {
      console.log("error get message", error)
    }
  }

  return (
    <div
      className="main-content w-100"
      style={{ maxWidth: "780px", 
              display: "flex", 
              flexDirection: "column",
              alignItems: "center", 
              overflow: "hidden" }}
    >
      
      <ModalVerify
        show={showModal}
        valid={valid}
        loading={loading}
        message="Confirme el codigo"
        closeModal={() => setShowModal(false)}
        passPortal={() => {
          setShowModal(false);
          passPortal();
        }}
      />
      {codeSent && (
        <ConfirmCode
          confirm={confirm}
          phoneNumber={body.phoneNumber}
          performance="Cerrar"
          close={() => setCodeSent(false)}
        />
      )}
      <div className="pt-4">
      
        <div className="row justify-content-center">
          <h4 style={{ color: "#203e60" }}>Bienvenido!</h4>
        </div>
        <div className="row p-1">
          <div className="m-3 p-2" style={{ backgroundColor: "#ffe8a3", color: "#000"}}>
            <label className="text-muted" >
              Ingrese su número de teléfono
            </label>
          </div>
        </div>
      </div>
      <div
        className="w-100"
        style={{ paddingLeft: "15px", paddingRight: "15px", margin: "auto" }}
      >
        <div className="row w-100 m-0">
          <Cel confirm={sentSMS} loading={loadingAskCode} msgBtn={codeSent ? "Re-enviar Código" : "Enviar Código"} />
        </div>
        {
          erroAskCode && (
            <div className="row w-100 m-0">
              <div
                      className={`alert alert-danger alert-dismissible fade show`}
                      role="alert"
                    >
                      {erroAskCode}
                      <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="Close"
                        onClick={() => setErroAskCode("")}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
            </div>
          )
        }
        
      </div>
    </div>
  );
};
